
import React from 'react'

export default class Input extends React.Component {

  constructor() {
    super()

    // Setup state
    this.state = {}
    this.state.focused = false

  }

  render() {

    // Apply default style
    var style = {
      borderBottom: '2px solid #DDD',
      display: 'flex',
      alignItems: 'center',
      color: '#333',
      fontSize: 15,
      width: '100%'
    }

    // Apply active style
    if (this.state.focused) Object.assign(style, {
      borderBottom: '2px solid #08F'
    })

    // Render button
    return <div style={Object.assign({ width: '100%' }, this.props.style)}>
      <div className='parentInput' style={style}>
        <div style={{
          display: this.props.leftText ? 'inline-block' : 'none',
          padding: 8,
          font: 'inherit',
          color: 'inherit'
        }}
          onClick={() => this.props.onLeftClick && this.props.onLeftClick()}
        >
          {this.props.leftText}
        </div>
        <input className='inputstyles' ref='elem' value={this.props.value} placeholder={this.props.placeholder} type={this.props.type} style={{
          padding: '8px 2px',
          border: 'none',
          background: 'none',
          outline: 'none',
          flex: '1 1 auto',
          fontSize: 'inherit'
        }}
          onChange={this.props.onChange}
          onKeyDown={this.props.onKeyDown}
          onFocus={e => this.setState({ focused: true })}
          onBlur={e => this.setState({ focused: false })}
          autoCorrect={this.props.autoCorrect}
          autoCapitalize={this.props.autoCapitalize}
        />
      </div>
      {this.props.helperText && <div style={{ paddingLeft: 5, marginTop: 10, fontSize: 12, color: '#333' }} >{this.props.helperText}</div>}
    </div>

  }

  /** Allow users of this component to focus the element */
  focus() {

    // Focus field
    this.refs.elem.focus()

    // HACK: Focusing on a field while the transition animation is running causes the content to be off center!
    // Seems like a browser bug?
    var appContainer = document.getElementById('app-container')
    if (appContainer)
      appContainer.scrollLeft = 0

  }

}
